import { createContext, Dispatch, ReactElement, SetStateAction, useState, useMemo, useEffect } from 'react'

export const AuthorizationContext = createContext<{
  token: string
  setToken: Dispatch<SetStateAction<string>>
}>({
  token: '',
  setToken: () => {},
})

interface IAuthorizationContextProvider {
  children: ReactElement
}

export const AuthorizationContextProvider = ({ children }: IAuthorizationContextProvider) => {
  const [token, setTokenState] = useState<string>(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('token') || ''
    }

    return ''
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    }
  }, [token])

  const setToken: Dispatch<SetStateAction<string>> = (value) => {
    setTokenState((prev) => {
      const newValue = typeof value === 'function' ? value(prev) : value

      return newValue
    })
  }

  const contextValue = useMemo(() => ({ token, setToken }), [token])

  return <AuthorizationContext.Provider value={contextValue}>{children}</AuthorizationContext.Provider>
}
